import { apiManagerRequest } from '../../axios';
import Session from '../../utils/session';
import { STATUS_CODE } from '../../utils/utils';

export const getTermsAndConditionsMethod = (urlTerminosYCondiciones) => async () => {
  const userInfo = Session.getAuth();
  const url = urlTerminosYCondiciones + '?entidad=2&canal=2';
  try {
    const responseData = await apiManagerRequest.get(url);

    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      return responseData?.data?.[0];
    }
  } catch (e) {
    return {
      statusCode: e?.response?.status,
      error: true,
      message: e?.response?.data?.errorMessage,
    };
  }
};

export const updateTermsAndConditionsMethod =
  (urlTerminosYCondicionesCheckUpdate, updateTerms) => async () => {
    const userInfo = Session.getAuth();
    const idUsuario = userInfo?.modelEspecifico?.idUsuario;
    let url = `${urlTerminosYCondicionesCheckUpdate}/${idUsuario}/terminos/${updateTerms}/aceptar?entidad=2&canal=2`;
    let paramsToSend = {
      dispositivo: {
        id: '1.1.1.1',
        nombre: 'WEB',
      },
    };
    try {
      const responseData = await apiManagerRequest.post(url, paramsToSend);
      if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
        Session.updateAcceptedTerms(responseData.data?.resultado === 'ok');
        return responseData?.data;
      }
    } catch (e) {
      return {
        statusCode: e?.response?.status,
        error: true,
        message: e?.response?.data?.errorMessage,
      };
    }
  };

export const checkTermsAndConditionsMethod = (urlTerminosYCondiciones) => async () => {
  const userInfo = Session.getAuth();
  const idUsuario = userInfo?.modelEspecifico?.idUsuario;
  let url = `${urlTerminosYCondicionesCheckUpdate}/${idUsuario}/terminos?entidad=2&canal=2`;

  try {
    const responseData = await apiManagerRequest.get(url);
    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      return responseData?.data;
    }
  } catch (e) {
    return {
      statusCode: e?.response?.status,
      error: true,
      message: e?.response?.data?.errorMessage,
    };
  }
};
